import React from 'react'
import { BrowserView, MobileView } from 'react-device-detect'

import { ApplicationContainerProps, IOS_APP_URL } from '../types'
import { Paper, Skeleton, Typography } from '@mui/material'
import { useApp } from '../../AppContext/AppProvider'
import { checkCreditCardStatus } from '../../../services/creditCard.service'
import { CreditCardStatusResponse } from '../../../domain/creditCard'
import { CreditCardIcon } from '../../Icons/CreditCardIcon'
import { QrCode } from '../../Icons/QrCode'
import { DownloadAppStoreIcon } from '../../Icons/DownloadAppStoreIcon'
import { useFetch } from '../../../hooks/fetch.hook'

type Props = Pick<ApplicationContainerProps, 'creditApplications'>

export const CreditApplicationCompleted: React.FC<Props> = ({
  creditApplications
}) => {
  const { application } = useApp()

  const fetchCard = checkCreditCardStatus(application)

  const creditApplication = creditApplications.filter(
    (c) => c.status === 'accepted'
  )[0]

  const { loading: loadingCard, data: creditCard } = useFetch<
    CreditCardStatusResponse,
    string
  >(fetchCard, creditApplication.id)

  return (
    <div style={{ maxWidth: 350, position: 'relative' }}>
      <div style={{ textAlign: 'center', zIndex: 1, position: 'relative' }}>
        {loadingCard && !creditCard ? (
          <Skeleton
            variant="rectangular"
            sx={{ height: '8rem', width: '10rem', ml: 10, borderRadius: 5 }}
          />
        ) : (
          <CreditCardIcon
            style={{
              height: '7.5em',
              width: '10em',
              borderRadius: 10
            }}
          />
        )}
      </div>

      <Paper
        elevation={2}
        sx={{
          textAlign: 'center',
          p: 3,
          zIndex: 2,
          marginTop: -15.5,
          position: 'relative'
        }}
      >
        <Typography component="div" variant="h6">
          Looks Like You're Already a Cardholder
        </Typography>

        <Typography component="div" variant="caption" gutterBottom>
          You can manage your card in the Paceline App
        </Typography>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <MobileView>
            <DownloadAppStoreIcon
              sx={{ height: '3.5em', width: '5em' }}
              onClick={() => window.open(IOS_APP_URL)}
            />
          </MobileView>
          <BrowserView>
            <QrCode sx={{ height: '2.5em', width: '2.5em' }} />
          </BrowserView>
        </div>

        <BrowserView>
          <Typography component="div" variant="caption">
            Scan to download the Paceline app
          </Typography>
        </BrowserView>
      </Paper>
    </div>
  )
}
